RivalIQ.module('channels.views', function (views, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    views.DismissableView = RivalIQ.views.ItemView.extend({
        behaviors: {
            Dismissible: {}
        },

        ui: {
            contactUs: '.x-contact-us',
            notRightNow: '.x-not-right-now',
            dontAskAgain: '.x-dont-ask-again',
            remindMeLater: '.x-remind-me-later'
        },

        events: {
            'click @ui.contactUs': 'onContactUsClick',
            'click @ui.notRightNow': 'onNotRightNow',
            'click @ui.dontAskAgain': 'onDontAskAgain',
            'click @ui.remindMeLater': 'onRemindMeLater'
        },

        onContactUsClick: function () {

            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: 'boosted post analytics'
                })
            }));
        },

        onNotRightNow: function () {
            const me = this;
            const state = me.getOption('state');
            me.dashboardModel.dismiss(moment.utc().add(1, 'day'), state);
        },

        onDontAskAgain: function () {
            const me = this;
            const state = me.getOption('state');
            me.dashboardModel.dismiss(undefined, state);
        },

        onRemindMeLater: function () {
            const me = this;
            const state = me.getOption('state');
            me.dashboardModel.dismiss(moment.utc().add(7, 'day'), state);
        }
    });

    views.ChannelWall = views.DismissableView.extend({
        className: 'x-channel-wall',
        defaults: {
            size: 'text'
        },

        initialize: function (options) {
            const me = this;
            _.extend(me, options);
        },

        getTemplate: function () {
            const me = this;
            const size = me.getOption('size');
            let template = me.getOption('template');

            if (!template) {

                switch (size) {
                    case 'sunset':
                        template = '#channelsChannelWallSizeSunsetTemplate';
                        break;
                    case 'additional':
                        template = '#channelsChannelWallSizeAdditionalAuthTemplate';
                        break;
                    case 'button':
                        template = '#channelsChannelWallSizeButtonTemplate';
                        break;
                    case 'small':
                        template = '#channelsChannelWallSizeSmallTemplate';
                        break;
                    case 'large':
                        template = '#channelsChannelWallSizeLargeTemplate';
                        break;
                    default:
                        template = '#channelsChannelWallSizeTextTemplate';
                        break;
                }
            }

            return template;
        },

        loadData: function (callback) {
            const me = this;

            const userIds = me.getOption('userIds');

            if (_.size(userIds)) {
                RivalIQ.state.account.getUsers().done(function (users) {
                    me.users = _.map(userIds, function (id) {
                        const user = users.get(id);
                        return (user ? user.toJSON() : null);
                    });

                    me.users = _.compact(me.users);

                    callback();
                });
            } else {
                callback();
            }
        },

        buildDescription: function (channelName, users) {
            let firstNames = _.uniq(_.map(_.sortBy(users, 'first_name'), function (user) {
                const firstName = user.first_name;
                return (firstName ? (`<strong>${firstName}</strong>`) : null);
            }));

            firstNames = _.compact(firstNames);

            if (_.size(firstNames) > 1) {
                firstNames = `${_.initial(firstNames).join(', ')} and ${_.last(firstNames)} have `;
            } else {
                firstNames = `${_.head(firstNames)} has `;
            }

            return `${firstNames}already linked their ${channelName} account to Rival IQ. Would you like to authorize with your account to gain access to the pages you administer?`;
        },

        serializeData: function () {
            const me = this;

            const source = me.getOption('source');
            const data = _.defaults(RivalIQ.data.CompareData.sourceDetails[source], {
                channelWallImage: null
            });

            const users = me.users || [];

            const userAuthed = RivalIQ.state.user.hasValidCredentials(source);
            const userTokenExpired = _.find(users, {
                id: RivalIQ.state.user.get('id')
            });
            const title = me.getOption('title') || `Do you want to connect your ${data.name} Account?`;
            let description = me.getOption('description');

            let mailTo;
            if (users.length) {
                const emails = _.compact(_.map(users, 'email'));

                const company = RivalIQ.state.landscape.getCompanyById(me.getOption('companyId'));

                const subject = `${data.name} Access Expired in Rival IQ`;
                const body = `Hello,\n\nThe authentication Rival IQ uses to fetch ${data.name} data for ${company.get('name')
                } has expired. To fix, please visit ${window.location.href}\n\n` +
                           'Until this action has been taken Rival IQ will be unable to fetch new data for this presence.\n\n' +
                           `Thanks\n${RivalIQ.state.user.get('first_name')}`;

                mailTo = `${emails.join(',')}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

                if (!description) {
                    description = me.buildDescription(data.name, users);
                }
            }

            return _.extend({
                url: RivalIQ.channels.getOAuthUrl(source),
                dataType: (source === RivalIQ.data.CompareData.sources.FACEBOOK ? 'Insights data' : 'data'),
                userAuthed: userAuthed,
                userTokenExpired: userTokenExpired,
                mailTo: mailTo,
                users: users,
                isExport: me.options.isExport,
                title: title,
                description: description,
                buttonName: data.name
            }, data);
        },

        onShow: function () {
            const me = this;

            const size = me.getOption('size');
            const source = me.getOption('source');
            const type = me.getOption('wallType') || 'normal';
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedChannelWall, {
                size: size,
                source: source,
                type: type
            });
        }
    });

}, window.moment);
